import React from 'react';
import PropTypes from 'prop-types';

const SmallError = ({ children }) => (
    <div className="pam">
        <div className="bas border-cherry r-pal cherry">{children}</div>
    </div>
);

SmallError.propTypes = {
    children: PropTypes.node.isRequired,
};

export default SmallError;



// WEBPACK FOOTER //
// ./safeTrade/errors/smallError.jsx